import { render, staticRenderFns } from "./Vozila.vue?vue&type=template&id=0c0b73dc&scoped=true&"
import script from "./Vozila.vue?vue&type=script&lang=ts&"
export * from "./Vozila.vue?vue&type=script&lang=ts&"
import style0 from "./Vozila.vue?vue&type=style&index=0&id=0c0b73dc&scoped=true&lang=css&"
import style1 from "./Vozila.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0b73dc",
  null
  
)

export default component.exports